import { useQuery } from 'react-query';
import { MainQuestionResponse } from './mainQuestionsTypes';
import { getMainQuestionById } from './mainQuestionsService';

type Props<M> = {
    id: string;
    onError?: (error: Error) => void;
    onSuccess?: (data: MainQuestionResponse) => void;
    mapper?: (
        data?: MainQuestionResponse
    ) => M | MainQuestionResponse | undefined;
    enabled?: boolean;
};

const defaultMapper = (data?: MainQuestionResponse) => data;

export const useGetMainQuestion = <M = MainQuestionResponse>({
    onError = () => {},
    onSuccess = () => {},
    mapper = defaultMapper,
    enabled = true,
    id,
}: Props<M>) => {
    const query = useQuery<MainQuestionResponse, Error>(
        ['mainQuestion', id],
        () => getMainQuestionById(id),
        {
            onSuccess,
            onError,
            enabled: enabled,
        }
    );

    return {
        data: mapper(query.data) as M,
        isLoading: query.isLoading,
        error: query.error,
        query,
    };
};
